import chatbotRequest from '../http'
import type { OfflineChannelReq, OfflineChannelRes } from '../types/offlineChannel'

export function offlineChannelApi(data: OfflineChannelReq): Promise<OfflineChannelRes> {
    return chatbotRequest<OfflineChannelRes, OfflineChannelReq, OfflineChannelRes>({
        url: '/api/channel/offline',
        method: 'post',
        data,
    })
}